import { render } from "./PropertyDetailsView.vue?vue&type=template&id=1ccc60b2&scoped=true"
import script from "./PropertyDetailsView.vue?vue&type=script&lang=js"
export * from "./PropertyDetailsView.vue?vue&type=script&lang=js"

import "./PropertyDetailsView.vue?vue&type=style&index=0&id=1ccc60b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccc60b2"]])

export default __exports__